import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Subject, takeUntil } from 'rxjs';
import { RecentlyAwardedContractsDataService } from '../../data-access/widgets/recently-awarded-contracts-data.service';

@Component({
  selector: 'app-recently-awarded-contracts-widget',
  template: `
    <app-dashboard-card title="Recently Awarded Contracts">
      <div *ngIf="loading">Loading contracts...</div>
      <div *ngIf="!loading && error" class="error">{{ error }}</div>
      <div *ngIf="!loading && !error && items.length === 0">No contracts</div>
      <mat-list *ngIf="!loading && !error && items.length > 0" class="dashboard-scroll-list">
        <mat-list-item class="dashboard-scroll-list-item" *ngFor="let item of items; trackBy: trackByContract" (click)="selectContract(item)">{{ item.shortContractType || item.name }}</mat-list-item>
      </mat-list>
    </app-dashboard-card>
  `,
  styles: [
    `.dashboard-scroll-list { display: block; max-height: 280px; overflow-y: auto; background: var(--table-row-bg); border-radius: 6px; }`,
    `.dashboard-scroll-list-item { min-height: 36px; cursor: pointer; color: var(--table-heading); }`,
    `.dashboard-scroll-list-item:nth-child(odd) { background: var(--table-row-bg); }`,
    `.dashboard-scroll-list-item:nth-child(even) { background: var(--table-row-alternate-bg); }`,
    `.dashboard-scroll-list-item:hover { background: var(--table-row-hover); }`,
    `@media (max-width: 768px) { .dashboard-scroll-list { max-height: 220px; } }`
  ]
})
export class RecentlyAwardedContractsWidgetComponent implements OnInit, OnDestroy {
  items: any[] = [];
  loading = false;
  error = '';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly dataService: RecentlyAwardedContractsDataService,
    private readonly stateService: StateService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.error = '';
    this.dataService.getContracts()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: items => this.items = Array.isArray(items) ? items : [],
        error: () => {
          this.error = 'Unable to load contracts';
          this.items = [];
        },
        complete: () => this.loading = false
      });
  }

  selectContract(item: any): void {
    const contractId = String(item?.contractID || '').trim();
    if (!contractId) {
      return;
    }

    const type = String(item?.shortContractType || item?.name || '').trim();
    this.stateService.go('search.contract', {
      contractID: contractId,
      contractDescription: '/' + encodeURIComponent(type)
    });
  }

  trackByContract(_: number, item: any): string {
    return String(item?.contractID || item?.id || item?.shortContractType || '');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
